import { TAG_COLOR, TAG_SIZE, TAG_STATUS, TAG_STYLE, TAG_TYPE } from "./types";

export const tagSize = {
  [TAG_SIZE.LARGE]: {
    [TAG_TYPE.ROUNDED]: "h-10 body-md  rounded-full  px-2.5",
    [TAG_TYPE.SQUARE]: "h-10 rounded-8 body-md px-2.5",
  },
  [TAG_SIZE.MEDIUM]: {
    [TAG_TYPE.ROUNDED]: "h-8   rounded-full body-sm px-2",
    [TAG_TYPE.SQUARE]: "h-8   rounded-8 px-2  body-sm",
  },
  [TAG_SIZE.SMALL]: {
    [TAG_TYPE.ROUNDED]: "h-6  rounded-full px-1 body-xsm",
    [TAG_TYPE.SQUARE]: "h-6  rounded-8 px-1 body-xsm",
  },
};

export const closeIconSize = {
  [TAG_SIZE.LARGE]: "h-5    w-5",
  [TAG_SIZE.MEDIUM]: "h-4     w-4",
  [TAG_SIZE.SMALL]: "h-3  w-3",
};

export const tagClassName = {
  [TAG_COLOR.DEFAULT]: {
    [TAG_STYLE.FILL]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-fds-inverse-primary ",
        text: "text-fds-on-inverse",
        border: "",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-fds-inverse-secondary ",
        text: "hover:text-fds-on-inverse",
        border: "",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-inverse-tertiary ",
        text: "active:text-fds-on-inverse",
        border: "",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable ",
        text: "disabled:text-fds-disable",
        border: "",
      },
    },
    [TAG_STYLE.LIGHT]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-fds-secondary",
        text: "text-fds-primary",
        border: "",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-fds-secondary-hover",
        text: "hover:text-fds-primary",
        border: "",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-secondary-select",
        text: "active:text-fds-primary",
        border: "",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "",
      },
    },
    [TAG_STYLE.OUTLINE]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-white",
        text: "text-fds-primary",
        border: "border border-fds-default",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-white",
        text: "hover:text-fds-primary",
        border: "hover:border hover:border-default-hover",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-secondary",
        text: "active:text-fds-primary",
        border: "active:border active:border-fds-select",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-white",
        text: "disabled:text-fds-disable",
        border: "disabled:border disabled:border-fds-disable",
      },
    },
  },
  [TAG_COLOR.BRAND]: {
    [TAG_STYLE.FILL]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-fds-brand ",
        text: "text-fds-on-brand",
        border: "",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-fds-brand-hover ",
        text: "hover:text-fds-on-brand",
        border: "",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-select focus:bg-fds-brand-select ",
        text: "active:text-fds-on-brand focus:text-fds-on-brand",
        border: "",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable ",
        text: "disabled:text-fds-disable",
        border: "",
      },
    },
    [TAG_STYLE.LIGHT]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-fds-brand-light",
        text: "text-fds-on-brand-light",
        border: "",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-fds-brand-light-hover",
        text: "hover:text-fds-on-brand-light-hover",
        border: "",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-select focus:bg-fds-brand-select",
        text: "active:text-fds-on-brand focus:text-fds-on-brand",
        border: "",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "",
      },
    },
    [TAG_STYLE.OUTLINE]: {
      [TAG_STATUS.DEFAULT]: {
        bg: "bg-white",
        text: "text-fds-brand",
        border: "border border-fds-brand",
      },
      [TAG_STATUS.HOVER]: {
        bg: "hover:bg-white",
        text: "hover:text-fds-brand-hover",
        border: "hover:border hover:border-brand-hover",
      },
      [TAG_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-light focus:bg-fds-brand-light ",
        text: "active:text-fds-brand-select focus:text-fds-brand-select",
        border:
          "active:border active:border-fds-brand-select focus:border-fds-brand-select",
      },
      [TAG_STATUS.DISABLE]: {
        bg: "disabled:bg-white",
        text: "disabled:text-fds-disable",
        border: "disabled:border disabled:border-fds-disable",
      },
    },
  },
};
